// extracted by mini-css-extract-plugin
export default {"body":"style-module--body--oVcqE"};